import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'agencyFormat',
    standalone: false
})
export class AgencyFormatPipe implements PipeTransform {
  transform(agencyNumber: string, agencyDigit?: string): string {
    if (!agencyNumber) return '';
    let num = agencyNumber.replace(/^0+/, '');
    num = num.padStart(4, '0');
    if (agencyDigit && agencyDigit.trim() !== '') {
      return `${num}-${agencyDigit}`;
    }
    return num;
  }
}
